import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UploadComponent } from './upload.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [UploadComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [UploadComponent]
})
export class UploadModule {}
